import { Chip, Tooltip } from "@mui/material";
import RouterLink from "@poseidon/ui/components/RouterLink";
import { formatCurrency } from "@poseidon/utils/currency";
import { filterOperators } from "../DataGrid/ColumnHelpers";

const dateColumn = (props) => ({
  width: 110,
  type: "date",
  valueFormatter: ({ value }) => value?.toLocaleDateString("en-GB") ?? "",
  ...props,
});

const currencyColumn = (props) => ({
  width: 130,
  type: "number",
  valueFormatter: ({ value }) => formatCurrency(value, true) ?? "",
  ...props,
});

const STATUS_LABELS = {
  U: "Not yet due",
  0: "Up to date",
  8: "Default",
};

export const getCaisColumns = () => [
  { field: "id" },
  {
    field: "agreementNumber",
    headerName: "Agreement",
    width: 120,
    filterOperators,
    renderCell: ({ row, value }) => (
      <RouterLink to={`/agreements/${row.agreementId}`}>{value}</RouterLink>
    ),
  },
  {
    field: "accountNumber",
    headerName: "CAIS Account",
    width: 190,
    filterOperators,
    renderCell: ({ value }) => (
      <span style={{ fontFamily: "monospace", whiteSpace: "pre" }}>{value}</span>
    ),
  },
  {
    field: "name",
    headerName: "Name",
    width: 220,
    filterOperators,
    renderCell: ({ row, value }) => (
      <RouterLink to={`/sailors/${row.sailorId}`}>{value}</RouterLink>
    ),
  },
  {
    field: "agreementStatus",
    headerName: "Agreement Status",
    width: 140,
    filterOperators,
  },
  {
    field: "accountStatus",
    headerName: "CAIS Status",
    width: 130,
    filterOperators,
    renderCell: ({ value }) => (
      <Tooltip
        title={STATUS_LABELS[value] ?? `${value} month(s) in arrears`}
      >
        <Chip
          size="small"
          label={value}
          color={
            value === "U" ? "default" : value === "0" ? "success" : "error"
          }
        />
      </Tooltip>
    ),
  },
  dateColumn({ field: "startDate", headerName: "Start" }),
  dateColumn({ field: "closeDate", headerName: "Closed" }),
  currencyColumn({ field: "monthlyPayment", headerName: "Monthly" }),
  {
    field: "repaymentPeriod",
    headerName: "Term",
    type: "number",
    width: 80,
  },
  currencyColumn({ field: "currentBalance", headerName: "Balance" }),
  {
    field: "duePayments",
    headerName: "Due",
    type: "number",
    width: 70,
  },
  { field: "address", headerName: "Address", width: 320, filterOperators },
  dateColumn({ field: "dateOfBirth", headerName: "DOB" }),
  {
    field: "warningCount",
    headerName: "Warnings",
    type: "number",
    width: 110,
    renderCell: ({ row, value }) =>
      value > 0 ? (
        <Tooltip
          title={
            <ul style={{ margin: 0, paddingLeft: 16 }}>
              {row.warnings.map((warning) => (
                <li key={warning}>{warning}</li>
              ))}
            </ul>
          }
        >
          <Chip size="small" color="warning" label={value} />
        </Tooltip>
      ) : null,
  },
];
